import { render, staticRenderFns } from "./ModalAvatar.vue?vue&type=template&id=a86b821e&scoped=true&"
import script from "./ModalAvatar.vue?vue&type=script&lang=js&"
export * from "./ModalAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ModalAvatar.vue?vue&type=style&index=0&id=a86b821e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86b821e",
  null
  
)

export default component.exports